<template>
  <TableBox :current-page="currentPage" :meta="meta" @onChangePage="$emit('onChangePage', $event)">
    <b-table
      sticky-header
      id="my-table"
      :fields="fields"
      :items="list"
      :busy="isLoading"
      class="custom-table"
      thead-class="custom-table-header"
      tbody-tr-class="custom-table-body"
      :empty-text="$t('customers.emptyText')"
      show-empty
    >
      <template #cell(name)="data">
        {{ data.item | fullName }}
      </template>

      <template #cell(createdAt)="data">
        <span class="text-nowrap">
          {{ data.item.createdAt | moment('YYYY-MM-DD') }}
        </span>
      </template>

      <template #cell(productSalesSumTotalAmount.amount)="data">
        {{
          data.item.productSalesSumTotalAmount
            ? $options.filters.currency(data.item.productSalesSumTotalAmount.amount)
            : ''
        }}
      </template>

      <template #cell(details)="data">
        <div class="table-action-buttons">
          <InlineButton
            v-if="me.isAdmin"
            variant="outline-secondary"
            size="sm"
            pill
            @click="$emit('onShowDetails', data.item.id)"
            class="has-shadow"
          >
            {{ $t('text.details') }}
          </InlineButton>
        </div>
      </template>
    </b-table>
  </TableBox>
</template>

<script>
import meMixin from '@/mixins/meMixin';
import TableBox from '@/components/ui/TableBox';
import InlineButton from '@/components/ui/button/InlineButton';

export default {
  mixins: [meMixin],
  props: {
    isLoading: Boolean,
    meta: Object,
    currentPage: Number,
    list: Array,
  },
  data() {
    return {
      fields: [
        {
          key: 'name',
          label: this.$t('table.th.name'),
        },
        {
          key: 'phone',
          label: this.$t('table.th.phoneNumber'),
        },
        {
          key: 'email',
          label: this.$t('table.th.email'),
        },
        {
          key: 'createdAt',
          label: this.$t('table.th.registered'),
        },
        // {
        //   key: 'productSalesCount',
        //   label: this.$t('table.th.totalOrders'),
        // },
        // {
        //   key: 'productSalesSumTotalAmount.amount',
        //   label: this.$t('table.th.totalSpent'),
        // },
        {
          key: 'details',
          label: this.$t('table.th.settings'),
        },
      ],
    };
  },
  components: {
    TableBox,
    InlineButton,
  },
};
</script>
